import React from 'react'
import Link from 'next/link'
import Button from '@/components/CommonComponent/button'
const LeadBanner = ({ props }: any) => {
    return (
        <div>
            <div className='w-full bg-gradient-to-b px-4 from-blue to-middleblue py-10 text-white  lg:py-16'>
                <div className=' md:w-[75%] mx-auto xl:w-[50%]'>
                    <div className=' text-[18px] sm:text-[20px] md:text-[28px] font-bold text-center lg:leading-[46px] 2xl:text-[38px]'>
                        {props.title}
                    </div>
                    <div className='text-white text-center mt-4' dangerouslySetInnerHTML={{ __html: props?.description }} />
                    <div className='flex flex-wrap mt-8 justify-center gap-4'>
                        {
                            props.link_url1 &&
                            <Link href={`/${props.link_url1}` || ''}>
                                <Button content={props.link_text1} />
                            </Link>
                        }
                        {
                            props.link_url2 &&
                            <Link href={props.link_url2 || ''}>
                                <Button content={props.link_text2} />
                            </Link>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LeadBanner